import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Feedback() {
  const [commenttext, setCommentText] = useState("");
  const [feedbackcomment, setFeedbackComment] = useState("");
  const [rating, setFeedbackRating] = useState("");
  const [feedbackfiles, setFeedbackFiles] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [pageContent, setPageContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEligible, setIsEligible] = useState(false);
  const [isCheckingEligibility, setIsCheckingEligibility] = useState(true);
  const userid = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const feedbackFiles = Array.from(event.target.files);
    setFeedbackFiles(feedbackFiles);
  };

  const hideErrorMessage = () => {
    setErrorMessage("");
  };

  const checkEligibility = async () => {
    setIsCheckingEligibility(true);
    setIsEligible(false); // Reset eligibility state to ensure fresh check

    if (!userid || userRole !== "member") {
      setIsEligible(false);
      setIsCheckingEligibility(false);
      return;
    }

    const storedLoginResponse = localStorage.getItem("loginResponse");
    const loginResponse = storedLoginResponse
      ? JSON.parse(storedLoginResponse)
      : null;
    const token = loginResponse?.data?.tokan || localStorage.getItem("adminToken");

    if (!token) {
      setIsEligible(false);
      setIsCheckingEligibility(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/zoom/getMeetings`,
        {
          params: { userId: userid },
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const meetings = response.data.data || [];
      const hasCompletedService = meetings.some(
        (meeting) =>
          (meeting.type === "videochat" || meeting.type === "singlevacationconsulatant") &&
          ["complete", "End", "Done"].includes(meeting.status)
      );

      setIsEligible(hasCompletedService);
    } catch (error) {
      console.error("Error checking eligibility:", error);
      setIsEligible(false);
      toast.error("Unable to verify eligibility. Please try again.");
    } finally {
      setIsCheckingEligibility(false);
    }
  };

  const handleSubmit = async (submitevent) => {
    submitevent.preventDefault();

    if (!commenttext || !feedbackcomment || !rating) {
      setErrorMessage("Please fill out all the required fields.");
      setTimeout(hideErrorMessage, 5000);
      return;
    }

    const formData = new FormData();
    feedbackfiles.forEach((file) => {
      formData.append("attachfile", file);
    });
    formData.append("title", commenttext);
    formData.append("comments", feedbackcomment);
    formData.append("rating", rating);
    formData.append("user_id", userid);

    const storedLoginResponse = localStorage.getItem("loginResponse");
    const loginResponse = storedLoginResponse
      ? JSON.parse(storedLoginResponse)
      : null;
    const token = loginResponse?.data?.tokan || localStorage.getItem("adminToken");

    try {
      const feedback_response = await axios.post(
        `${process.env.REACT_APP_API_URL}/feedback/add/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage("Feedback sent successfully! Redirecting in 5 seconds...");
      setTimeout(() => {
        navigate("/customerfeedback");
      }, 5000);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setErrorMessage("Failed to submit feedback. Please try again.");
      setTimeout(hideErrorMessage, 5000);
    }
  };

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/pages/slug/feedback`
        );
        setPageContent(response.data.data[0]);
      } catch (error) {
        console.error("Error fetching page content:", error);
      }
    };

    Promise.all([fetchPageContent(), checkEligibility()]).finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading || isCheckingEligibility) {
    return (
      <div className="loading-overlay">
        <img src="/img/loader.gif" alt="Loading" />
      </div>
    );
  }

  if (!pageContent) {
    return null;
  }

  if (!userRole) {
    return (
      <section className="video-chat-form-sec secpd70">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h3>Please Log In</h3>
              <p>You need to be logged in to submit feedback.</p>
              <Link to="/login" className="btn btn-primary">
                Log In
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!isEligible) {
    return (
      <section className="video-chat-form-sec secpd70">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h3>Access Restricted</h3>
              <p>
                The feedback form is only available to members who have completed a
                Video Chat or Singles Vacation Consultation service.
              </p>
              <Link to="/customerfeedback" className="btn btn-primary">
                All Customer Reviews
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  const style = {
    backgroundImage: `url('${pageContent.bannerurl}')`,
  };

  return (
    <>
      <section className="page-info-sec">
        <div className="bg-fixed" style={style}></div>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <div className="page-info-block">
                <h1>{pageContent ? pageContent.bannertitle : "Feedback"}</h1>
                <p>
                  {pageContent
                    ? pageContent.bannerdesc
                    : "Lorem ipsum dolor sit amet, consectetur adipiscing elit..."}
                </p>
                <p className="page_nav">
                  <a href="/">Home</a>/
                  <a href="#" className="currentPage">
                    {pageContent ? pageContent.bannertitle : "Feedback"}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-chat-form-sec secpd70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {successMessage && (
                <div className="alert alert-success mt-3 text-center" role="alert">
                  {successMessage}
                </div>
              )}
              {errorMessage && (
                <div className="alert alert-danger mt-3" role="alert">
                  {errorMessage}
                </div>
              )}
              <div className="main-from-wrap">
                <div className="main-from-inner-wrap">
                  <div className="title-centered text-center">
                    <h2 className="title-30 mb-3">How was your Experience?</h2>
                    <p>
                      If you have bought a service and wish to discuss your experience,
                      please fill out this review form.
                    </p>
                  </div>

                  <div className="formwrapper">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3 mb-md-4">
                            <label>
                              Rate<span className="required">*</span>
                            </label>
                            <div className="rating_box_wrap">
                              <input
                                type="radio"
                                name="rating"
                                value="1"
                                onChange={(e) => setFeedbackRating(e.target.value)}
                              />
                              <input
                                type="radio"
                                name="rating"
                                value="2"
                                onChange={(e) => setFeedbackRating(e.target.value)}
                              />
                              <input
                                type="radio"
                                name="rating"
                                value="3"
                                onChange={(e) => setFeedbackRating(e.target.value)}
                              />
                              <input
                                type="radio"
                                name="rating"
                                value="4"
                                onChange={(e) => setFeedbackRating(e.target.value)}
                              />
                              <input
                                type="radio"
                                name="rating"
                                value="5"
                                onChange={(e) => setFeedbackRating(e.target.value)}
                              />
                              <div className="rating_box"></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3 mb-md-4">
                            <label>
                              Title<span className="required">*</span>{" "}
                              <small>(Limit to 100 characters)</small>
                            </label>
                            <input
                              type="text"
                              id="title"
                              name="title"
                              className="form-control"
                              placeholder="Journey of life"
                              value={commenttext}
                              onChange={(e) => setCommentText(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3 mb-md-4">
                            <label>
                              Comment<span className="required">*</span>{" "}
                              <small>(Limit to 500 characters)</small>
                            </label>
                            <textarea
                              name="comments"
                              id="comments"
                              className="form-control"
                              rows="4"
                              placeholder="Lorem ipsum doler sit amet elit"
                              value={feedbackcomment}
                              onChange={(e) => setFeedbackComment(e.target.value)}
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mb-3 mb-md-4">
                            <label className="c_file-upload">
                              <input
                                name="attachfile"
                                id="attachfile"
                                type="file"
                                onChange={handleFileChange}
                                multiple
                              />
                              <button className="btn btn-outline-primary">
                                <i className="fa fa-cloud-upload"></i> Upload Picture
                              </button>
                              <span className="choosefile">Choose Files</span>
                            </label>
                            <p className="small">
                              Limited between 1 and 10 photos (under 10 MB of file size)
                            </p>
                          </div>
                        </div>

                        <div className="col-md-1"></div>
                        <div className="col-md-10">
                          <button type="submit" className="btn-1 w-100">
                            Submit
                          </button>
                        </div>
                        <div className="col-md-1"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Feedback;